import { Tooltip } from 'antd';

// ════════════════════════════════════════════════════════════════════
// Stage WO-LINES-GRID — Work Order detail "Production stages" matrix.
//
// A compact, read-only per-department board (mirrors the shop's PRODUCTION
// tracking row) counted by PIECE: each department cell shows how many of the
// routed pieces have cleared that stage — `done/routed` — "—" when the stage
// isn't in any route, green when every routed piece is done. Overall piece
// completion (pieces produced to completion) sits above the matrix.
//
// Data: `stageColumns` + `stageProgress` from workOrderQuery.getById.
// ════════════════════════════════════════════════════════════════════

const COL_W = 62;
const GRID_FONT = "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif";
const CSS = `
.wosm{font-family:${GRID_FONT};color:#0f172a;}
.wosm-scroll{position:relative;overflow-x:auto;border:1px solid #cbd5e1;border-radius:6px;background:#fff;box-shadow:0 1px 2px rgba(15,23,42,.04);}
.wosm-grid{display:inline-block;min-width:100%;}
.wosm-ghdr{display:flex;align-items:center;justify-content:center;height:24px;background:#eef2f7;color:#475569;font-size:10px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;border-bottom:1px solid #cbd5e1;}
.wosm-hrow,.wosm-vrow{display:flex;}
.wosm-hcell{flex:0 0 auto;display:flex;align-items:center;justify-content:center;height:26px;background:#f6f8fb;color:#475569;font-size:10px;font-weight:700;letter-spacing:.03em;border-right:1px solid #e6ebf1;border-bottom:1px solid #cbd5e1;text-transform:uppercase;}
.wosm-vcell{flex:0 0 auto;display:flex;align-items:center;justify-content:center;height:34px;border-right:1px solid #eef1f5;font-size:12px;font-variant-numeric:tabular-nums;}
.wosm-hcell:last-child,.wosm-vcell:last-child{border-right:none;}
.wosm-v{color:#334155;font-weight:600;}
.wosm-v.full{color:#16a34a;}
.wosm-zero{color:#cbd5e1;}
`;

function cell(done, routed) {
  if (!routed) return <span className="wosm-zero">—</span>;
  const full = done >= routed;
  return (
    <Tooltip title={`${done} of ${routed} pieces cleared`}>
      <span className={full ? 'wosm-v full' : 'wosm-v'}>{done}/{routed}</span>
    </Tooltip>
  );
}

export default function WorkOrderStageMatrix({ stageColumns, stageProgress }) {
  const cols = Array.isArray(stageColumns) ? stageColumns : [];
  if (!cols.length) return null;
  const width = cols.length * COL_W;

  return (
    <div className="wosm">
      <style>{CSS}</style>
      <div className="wosm-scroll">
        <div className="wosm-grid" style={{ minWidth: width }}>
          <div className="wosm-ghdr" style={{ width }}>PRODUCTION</div>
          <div className="wosm-hrow">
            {cols.map((c) => (
              <div key={c.code} className="wosm-hcell" style={{ width: COL_W }}>
                <Tooltip title={`${c.name} — pieces cleared / routed`}>{c.letter}</Tooltip>
              </div>
            ))}
          </div>
          <div className="wosm-vrow">
            {cols.map((c) => {
              const s = (stageProgress && stageProgress[c.code]) || { done: 0, routed: 0 };
              return (
                <div key={c.code} className="wosm-vcell" style={{ width: COL_W }}>
                  {cell(Number(s.done) || 0, Number(s.routed) || 0)}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
